<ion-header class="ion-no-border">
  @let stopData = nextStop();
  @let freightDetailData = freightDetail();
  @let stopDetailData = nextStop();
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="cancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'freight.detail.arrival_at_stop' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  @if (isLoading() || !stopData) {
    <lib-spinner-loading></lib-spinner-loading>
  } @else {
    <ion-grid class="ion-no-padding">
      <ion-row class="ion-padding-bottom">
        <ion-col
          size="12"
          [sizeLg]="6"
        >
          <div
            class="step step--active"
            [class.step--to-upload]="stopData.type === EStopType.LOAD"
            [class.step--to-download]="stopData.type === EStopType.UNLOAD"
          >
            @if (stopData.type === EStopType.LOAD) {
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/upload_24dp.svg"
              ></ion-icon>
            } @else if (EStopType.UNLOAD) {
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/download_24dp.svg"
              ></ion-icon>
            }
            <div>
              <div class="step-type">
                @if (stopData.type === EStopType.LOAD) {
                  {{ 'freight.detail.load' | translate }}:
                } @else if (stopData.type === EStopType.UNLOAD) {
                  {{ 'freight.detail.unload' | translate }}:
                }
              </div>
              <lib-freight-carrier-inprogress-card-address
                [address]="stopData.address"
              ></lib-freight-carrier-inprogress-card-address>
            </div>
          </div>
        </ion-col>
        <ion-col
          size="12"
          [sizeLg]="6"
        >
          <lib-freight-carrier-inprogress-card-schedule
            [since]="stopData.since"
            [until]="stopData.until"
          ></lib-freight-carrier-inprogress-card-schedule>
        </ion-col>
      </ion-row>

      <ion-row>
        @if (freightDetailData.instructions !== undefined && freightDetailData.observations !== undefined) {
          <ion-col size="12">
            <div class="freight-data-block">
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/info_24dp.svg"
              ></ion-icon>
              <div>
                <p class="subtitle">{{ 'freight.detail.instructions' | translate }}</p>
                @if (freightDetailData.instructions !== undefined) {
                  <p>{{ freightDetailData.instructions }}</p>
                }
                @if (freightDetailData.observations !== undefined) {
                  <p>{{ freightDetailData.observations }}</p>
                }
              </div>
            </div>
          </ion-col>
        }
        @if (stopDetailData && stopDetailData.reference !== undefined) {
          <ion-col
            size="12"
            [sizeLg]="6"
          >
            <div class="freight-data-block">
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/barcode_24dp.svg"
              ></ion-icon>
              <div>
                <p class="subtitle">{{ 'freight.detail.stop_reference' | translate }}</p>
                <p>{{ stopDetailData.reference }}</p>
              </div>
            </div>
          </ion-col>
        }
        @if (stopDetailData && stopDetailData.instructions !== undefined && stopDetailData.instructions !== '') {
          <ion-col
            size="12"
            [sizeLg]="6"
          >
            <div class="freight-data-block">
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/comment_24dp.svg"
              ></ion-icon>
              <div>
                <p class="subtitle">{{ 'freight.detail.instructions' | translate }}</p>
                <p>{{ stopDetailData.instructions }}</p>
              </div>
            </div>
          </ion-col>
        }
        @if (freightDetailData.vehicles.length) {
          <ion-col
            size="12"
            [sizeLg]="6"
          >
            <div class="freight-data-block">
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/local_shipping_24dp.svg"
              ></ion-icon>
              <div>
                <p class="subtitle">{{ 'freight.detail.asigned_vehicle' | translate }}</p>
                @for (vehicle of freightDetailData.vehicles; track vehicle.id) {
                  <p>
                    <span class="plate">{{ vehicle.plate }}</span>
                    @if (vehicle.type) {
                      {{ 'vehicleType.' + vehicle.type | translate }}
                    }
                  </p>
                }
              </div>
            </div>
          </ion-col>
        }
      </ion-row>

      <ion-row>
        <ion-col>
          <div class="freight-data-block">
            <ion-icon
              aria-hidden="true"
              src="../assets/material-symbols/where_to_vote_24dp.svg"
            ></ion-icon>
            <div>
              <p class="subtitle">{{ 'freight.detail.coords_app' | translate }}</p>

              <lib-freight-carrier-stop-geolocation
                (coordsChange)="onCoordsChange($event)"
              ></lib-freight-carrier-stop-geolocation>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <p
            class="fs-sm"
            [innerHTML]="'freight.detail.final_message_form' | translate"
          ></p>
        </ion-col>
      </ion-row>
    </ion-grid>
  }
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="confirm()"
            color="primary"
            expand="block"
            fill="solid"
            size="large"
          >
            {{ 'freight.detail.confirm_arrival' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
